/**
 * @author Mr_FabiozZz[mr.fabiozzz@gmail.com]
 */
import React, { PropsWithChildren } from "react";
import { createPortal } from "react-dom";

interface IPortal extends PropsWithChildren {
	containerRef: any;
}

export const PortalWrapper: React.FC<IPortal> = ({ children, containerRef }) => {
	if (!containerRef) return null;
	return createPortal(children, containerRef as HTMLElement);
};
